/*
  This mixins chack keyboard-navigation events, and if navigation active,
  interactive elements in page supports class with focus effect.
*/

export default {
    data: () => ({
        isKeyboardNavigation: false
    }),
    methods: {
        canNavigation(event) {
            if(event.code === 'Tab') {
                if(this.modalOrganism) {
                    this.isKeyboardNavigation = true
                    event.preventDefault()
                    const modal = Array.from(document.querySelectorAll('.o-modal-base button'))
                    let tabIdex = -1
                    modal.forEach((item, index) => {
                        if (item == document.activeElement) tabIdex = index
                    })
                    tabIdex !== modal.length - 1 ? modal[tabIdex + 1].focus() : modal[0].focus()
                } else {
                    this.isKeyboardNavigation = true
                }
            }
        },
        removeTabNavigation() {
            this.isKeyboardNavigation = false
        }
    },
    created() {
        document.addEventListener('keydown', this.canNavigation);
        document.addEventListener('mousedown', this.removeTabNavigation);
    },
    beforeDestroy() {
        document.removeEventListener('keydown', this.canNavigation);
        document.removeEventListener('mousedown', this.removeTabNavigation);
    }
}
